import { customerApi } from "../../utils/apiConfig";

export const uploadRulo = (userId, file) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("excel", file);

  return customerApi.post("/ruloStokAnaliz", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const uploadBand = (userId, file) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("excel", file);

  return customerApi.post("/bandStokAnaliz", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};


export const uploadProfil = (userId, file) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("excel", file);

  return customerApi.post("/profilStokAnaliz", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
export const uploadHammadde = (userId, file) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("excel", file);

  return customerApi.post("/gelecekHammaddeUpload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};



export const stokOzetAnaliz = () => {
  return customerApi.get(`/stokOzetAnaliz`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
}


